import { SearchInput, type SearchInputProps } from './SearchInput';

type ServerSearchInputProps = SearchInputProps & {
  hint?: string;
};

// Debounced input for filters that hit backend list endpoints instead of only filtering loaded rows.
export function ServerSearchInput({ hint, ...props }: ServerSearchInputProps) {
  return (
    <div className="space-y-1">
      <SearchInput {...props} />
      {hint && <p className="text-xs text-neutral-500">{hint}</p>}
    </div>
  );
}
